import { createSelector } from '@reduxjs/toolkit';
import { nutritionistAppointmentsAdapter } from 'features/appointments/state/nutritionist-appointments.slice';

export const { selectAll, selectById: nutritionistAppointmentByIdSelector } =
  nutritionistAppointmentsAdapter.getSelectors(
    state => state.wnNutritionistAppointments.appointments,
  );

const activeAppointmentIdSelector = state =>
  state.wnNutritionistAppointments.activeId;

const activeNutritionistAppointmentsSelector = createSelector(
  [selectAll],
  appointments => {
    const acceptedStatuses = ['accepted', 'pending', 'rescheduled'];
    return appointments.filter(appointment =>
      acceptedStatuses.includes(appointment.status),
    );
  },
);

const rejectedNutritionistAppointmentsSelector = createSelector(
  [selectAll],
  appointments => {
    return appointments.filter(
      appointment =>
        ['rejected', 'cancelled'].includes(appointment.status) &&
        appointment.lastActionRole === 'nutritionist',
    );
  },
);

export const nutritionistAppointmentsSelector = createSelector(
  [
    activeNutritionistAppointmentsSelector,
    rejectedNutritionistAppointmentsSelector,
  ],
  (activeAppointments, rejectedAppointments) => {
    return [...activeAppointments, ...rejectedAppointments];
  },
);

export const nutritionistAppointmentSelector = createSelector(
  [state => state, activeAppointmentIdSelector],
  (state, appointmentId) =>
    appointmentId
      ? nutritionistAppointmentByIdSelector(state, appointmentId)
      : null,
);

export const hasPendingNutritionistAppointmentsSelector = createSelector(
  [selectAll],
  appointments =>
    appointments.some(
      appointment =>
        appointment.status === 'pending' &&
        appointment.nextActionRole === 'client',
    ),
);

export const pendingNutritionistAppointmentSelector = createSelector(
  [selectAll],
  appointments =>
    appointments.find(
      appointment =>
        appointment.status === 'pending' &&
        appointment.nextActionRole === 'client',
    ),
);
